import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import LocationList from "./Location";
import API from '../Services/PartyProduct'
import ActivityType from "../Components/ActivityType";
import TaxRateListList from "./TaxRate";
import ProductModal from "./ProductModal";
import AddOnList from "../Components/AddOnList";
import CenterModal from "./CenterModal";

const ProductActivityList = () => {
    const [activityList, setActivityList] = useState([])
    const [error, setError] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [id, setId] = useState(null)
    const [status, setStatus] = useState("");
    const limit = 10;

    const [createdAt, setCreatedAt] = useState("");
    const [locationId, setLocationId] = useState("");
    const [activityName, setActivityName] = useState("");
    const [playPoint, setPlayPoint] = useState("");
    const [amount, setAmount] = useState("");
    const [timeValue, setTimeValue] = useState("");
    const [timeValue1, setTimeValue1] = useState("");
    const [activityTypeId, setActivityTypeId] = useState("");
    const [comboTax, setComboTax] = useState("")

    const [comboTaxName, setComboTaxName] = useState("")
    const [centerName, setCenterName] = useState("");
    const [activityTypeName, setActivityTypeName] = useState("");
    const [specialAmount, setSpecialAmount] = useState("")
    const [productId, setProductId] = useState([]);
    const [productName, setProductName] = useState([]);
    const [selectedActivityCenter, setSelectedActivityCenter] = useState([]);
    const staticHours = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    const staticMinutes = ["0", "15", "30", "45"];

    const [addOnId, setAddOnId] = useState(Number);
    const [isAddOn, setIsAddOn] = useState(Boolean);
    const [prevIsAddOn, setPrevIsAddOn] = useState(false)
    const [prevAddOnId, setPrevAddOnId] = useState(Number);
    const [mapAddonName, setMapAddonName] = useState("");
    const [selectedCenter, setSelectedCenter] = useState([]);

    useEffect(() => {
        getActivity()
    }, [currentPage]);

    const getActivity = async () => {
        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;
            const response = await API.getActivityList({
                page: currentPage,
                limit: 10,
                location_id: centerlist || null
                // location_id:
            });
            // console.log("reponse type Daat...", response?.data)
            setActivityList(response?.data?.data || []);
            setTotalRecords(response?.data?.totalItems)
        } catch (error) {
            setError((prevErrors) => ({
                ...prevErrors,
                duration: "Failed to fetch activity type data.",
            }));
            handleError(error);
        }
    };

    const handleError = (error) => {
        console.error("Error:", error);
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };
    const totalPages = Math.ceil(totalRecords / limit);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };
    const handleCheckboxChange = (e) => {
        if (e.target.checked) {
            setIsAddOn(prevIsAddOn || true);
            if (prevAddOnId) {
                setAddOnId(prevAddOnId);
            }
        } else {
            setPrevIsAddOn(isAddOn);
            setPrevAddOnId(addOnId);
            setIsAddOn(null);
            setAddOnId(null);
        }
    };

    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);
            if (left > 2) {
                pageNumbers.push(1, '...');
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push('...', totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    }

    const handleGetData = async (id) => {
        try {
            const response = await API.getActivityList({ id: id });
            const fetchedData = response?.data?.data?.[0];
            // console.log('ffffff AA', fetchedData);
            if (fetchedData) {
                const totalMinutes = parseFloat(fetchedData?.time);
                const hours = Math.floor(totalMinutes / 60);
                // console.log('hours', hours);
                const minutes = totalMinutes % 60;
                setId(fetchedData.id);
                setLocationId(fetchedData?.location_id)
                setActivityName(fetchedData?.name);
                setPlayPoint(fetchedData?.play_point)
                setAmount(fetchedData?.amount);
                setStatus(fetchedData?.is_active);
                setTimeValue(hours)
                setTimeValue1(parseFloat(fetchedData?.time))
                setCreatedAt(fetchedData?.createdAt);
                setActivityTypeId(fetchedData?.activity_type_id);
                setCenterName(fetchedData?.location_name);
                setActivityTypeName(fetchedData?.ActivityProductType?.name);
                setComboTax(fetchedData?.tax_rate_id);
                setComboTaxName(fetchedData?.tax_rate);
                setProductId(fetchedData?.map_product_id);
                setProductName(fetchedData?.map_product_name)
                setAddOnId(fetchedData?.map_addon_id)
                setMapAddonName(fetchedData?.map_addon_name)
                setSpecialAmount(fetchedData?.special_price)
                if (fetchedData?.map_addon_id == null) {
                    setIsAddOn(false);
                    console.log('No AddOn');
                } else {
                    setIsAddOn(true);
                    console.log('Has AddOn');
                }

            } else {
                toast.error("Failed to fetch  details.");
            }
        } catch (error) {
            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching data:", error);
        }
    };

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;

        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {

            case "activityName":
                setActivityName(value);
                break;
            case "amount":
                setAmount(value);
                break;
            // case "timeValue":
            //     setTimeValue(value);
            //     break;
            case "timeValue1":
                setTimeValue1(value);
                break;
            case "playPoint":
                setPlayPoint(value);
                break;
            case "specialAmount":
                setSpecialAmount(value);
                break;
            default:
                break;
        }
        if (fieldName === "playPoint") {
            setPlayPoint(value);
            if (value.trim() !== "") {
                setError((prev) => ({ ...prev, playPoint: "", time: "" }));
            } else if (!String(timeValue1).trim()) {
                setError((prev) => ({
                    ...prev,
                    playPoint: "Enter SkyCoins or Minutes",
                    time: "Minutes are required if SkyCoins is blank"
                }));
            }
        }

        if (fieldName === "timeValue1" || fieldName === "timeValue") {
            if (fieldName === "timeValue") setTimeValue(value);
            else setTimeValue1(value);

            if (!String(playPoint).trim()) {
                if (!value.trim()) {
                    setError((prev) => ({
                        ...prev,
                        time: "Minutes are required if SkyCoins is blank",
                        playPoint: "Enter SkyCoins or Minutes"
                    }));
                } else if (fieldName === "timeValue1" && value.trim()) {
                    setError((prev) => {
                        const updatedErrors = { ...prev };
                        delete updatedErrors.time;
                        delete updatedErrors.playPoint;
                        return updatedErrors;
                    });
                }
            }
        }

        if (fieldName === "amount") {
            setAmount(value);
            if (value.trim() !== "") {
                setError((prev) => ({ ...prev, amount: "" }));
            }
        }
    };

    const validateFields = () => {
        const errors = {};
        const priceRegex = /^\d+(\.\d{1,2})?$/;
        if (!activityName.trim()) errors.activityName = "Activity Name is required";

        const isPlayPointValid = playPoint && priceRegex.test(playPoint);
        const isTimeProvided = !!timeValue1;

        if ((isPlayPointValid && isTimeProvided) || (!isPlayPointValid && !isTimeProvided)) {
            errors.playPoint = "Choose either SkyCoins or Time (not both)";
            errors.time = "Choose either Time or SkyCoinst (not both)";
        }
        if (playPoint && !priceRegex.test(playPoint)) {
            errors.playPoint = "Valid SkyCoins is required";
        }
        if (!amount || !priceRegex.test(amount)) {
            errors.amount = "Valid Amount is required";
        }

        setError(errors);
        return Object.keys(errors).length === 0;
    };

    const handleUpdate = async () => {
        if (!validateFields()) return;
        if (!comboTax || comboTax.length === 0 || comboTax == 'Select') {
            toast.error("Tax Rate is required");
            return;
        }

        if (isAddOn === true) {
            if (!addOnId || addOnId.length === 0 || addOnId == 'Select') {
                toast.error("Add On is required");
                return;
            }
        }
        const timeValueHourse = parseFloat(timeValue) * 60;
        const time = parseFloat(timeValueHourse) + parseFloat(timeValue1);
        let addOnRequred = isAddOn !== "" !== "" ? isAddOn : false;
        try {
            const payload = {
                activity_type_id: parseInt(activityTypeId),
                name: activityName,
                display_order: 1,
                play_point: parseInt(playPoint),
                time: timeValue1,
                amount: parseFloat(amount),
                tax_rate_id: comboTax,
                map_product_id: productId || 0,
                is_addons: addOnRequred,
                map_addons: [addOnId],
                special_price: specialAmount || 0
            };
            // console.log('payload', payload);
            const response = await API.updateActivity(id, payload);
            if (response?.status === 200) {
                toast.success(response?.data?.message || "Add-on Activity Type successfully!");
                document.getElementById('closeUpdateModal')?.click();
                getActivity();
                // setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Failed to update Activity Type.");
            }
        } catch (error) {
            if (error.response?.status === 403) {
                window.location.replace("/Login");
            }
            toast.error(error.message);
        }
    };
    const changeStatus = async (id, currentStatus) => {
        // console.log("stauttsss..", id, currentStatus)
        const updatedStatus = !currentStatus;
        try {
            const response = await API.updateActivityStatus(id, updatedStatus);
            if (response.status === 200) {
                setActivityList((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(
                    `Activity ${updatedStatus ? "Activated" : "De-Activated"} successfully!`
                );
                getActivity();
            } else {
                console.log("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found (404)');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.log("Error in status toggle:", error);
            toast.error("Failed to update the status. Please try again.");
        }
    };

    const handleClose = () => {
        setAddOnId(false);
    }

    const handleSelectedCenter = (selectedData) => {
        setSelectedCenter(selectedData);
    };
    const handleSearch = () => {
        console.log('wwww');
        getActivity();
    }
    return (
        <div>

            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0"></h4>
                    </div>
                    <div className="card-body">
                        <div className="row mb-3">
                            <div className="col-md-4">
                                <CenterModal onSelectCenter={handleSelectedCenter} />
                            </div>
                            <div className="col-md-3">
                                <label></label>
                                <button
                                    type="button"
                                    className="btn btn-success mt-3"
                                    onClick={handleSearch}
                                >Search</button>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>

                                        <th>SrNo</th>
                                        <th>Action</th>
                                        <th>Activity Type</th>
                                        <th>Activity Name</th>
                                        <th>Center Name</th>
                                        {/* <th>SkyCoins</th> */}
                                        <th>Tax Rate</th>
                                        <th>Time</th>
                                        <th>MRP (Normal)</th>
                                        <th>MRP (SPCL)</th>
                                        <th>Status</th>
                                        <th>Created-Date</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {activityList && activityList.length > 0 ? (
                                        activityList.map((item, index) => (

                                            <tr key={item?.id || index} data-active={item?.is_active ? "true" : "false"}>
                                                <td>{(currentPage - 1) * limit + index + 1}</td>
                                                <td>
                                                    <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                        <ul className="navbar-nav navbar-nav-right">
                                                            <li className="nav-item nav-profile1">
                                                                <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <div className="nav-profile-text1">
                                                                        <p className="mb-1 text-black">
                                                                        </p>
                                                                    </div>
                                                                </span>
                                                                <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                                <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                                    <a className="dropdown-item">
                                                                        <button onClick={() => handleGetData(item?.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalActivityList">
                                                                            View
                                                                        </button>
                                                                    </a>
                                                                    <div className="dropdown-divider"></div>
                                                                    <a className="dropdown-item">
                                                                        <button onClick={() => handleGetData(item?.id)}
                                                                            className="btn btn-primary btn-sm" type="button"
                                                                            data-bs-toggle="modal" data-bs-target="#myModalactivityUpdate"
                                                                        >
                                                                            Edit
                                                                        </button>
                                                                    </a>
                                                                    <div className="dropdown-divider"></div>
                                                                    <a className="dropdown-item">

                                                                        <button
                                                                            className={`btn btn-sm ${item?.is_active ? "btn-secondary" : "btn-info"}`}
                                                                            onClick={() => changeStatus(item?.id, item?.is_active)}
                                                                        >
                                                                            {item?.is_active ? "De-Activate" : "Activate"}
                                                                        </button>

                                                                    </a>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                                <td>{item?.ActivityProductType?.name}</td>
                                                <td>{item?.name}</td>
                                                <td>{item?.location_name}</td>
                                                {/* <td>{item?.play_point}</td> */}
                                                <td>{item?.tax_rate}</td>
                                                <td>{item?.time}</td>

                                                <td>{item?.amount}</td>
                                                <td>{item?.special_price}</td>
                                                <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                                                <td>{moment(item?.createdAt).format("DD-MM-YYYY")}</td>

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="9">No Record found.</td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination justify-content-center mt-4">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Previous
                                        </button>
                                    </li>

                                    {getPageNumbers().map((page, index) => (
                                        <li
                                            key={index}
                                            className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                        >
                                            {page === "..." ? (
                                                <span className="page-link">...</span>
                                            ) : (
                                                <button className="page-link" onClick={() => handlePageChange(page)}>
                                                    {page}
                                                </button>
                                            )}
                                        </li>
                                    ))}

                                    <li
                                        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>

                </div>
            </div>

            <section>
                <div className="modal" id="myModalactivityUpdate" data-bs-backdrop="static">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Update Activity</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={handleClose}></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-3">
                                        <LocationList
                                            selectedLocation={locationId}
                                            label="Center Name"
                                            isRequired={false}
                                            disabled={true}
                                            setSelectedLocation={(location) => setLocationId(location)}
                                        />
                                    </div>

                                    <div className="col-md-3">
                                        <ActivityType
                                            selectedActivityType={activityTypeId}
                                            setSelectedActivityType={setActivityTypeId}
                                            selectedActivityCenter={locationId}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <ProductModal onSelectProduct={setProductId} type='edit' productId={productId} selectedActivityCenter={locationId} />

                                    </div>

                                    <div className="col-md-3">
                                        <label>Activity Name <span className="text-danger">*</span></label>
                                        <input
                                            className="form-control"
                                            placeholder="Activity Name"
                                            value={activityName}
                                            onChange={(e) => handleFieldChange(e, "activityName")}
                                        />
                                        {error.activityName && <small className="text-danger">{error.activityName}</small>}
                                    </div>


                                </div>

                                <div className="row mt-3">
                                    <div className="col-md-3">
                                        <TaxRateListList selectedTaxRate={comboTax} setSelectedTaxRate={setComboTax}
                                            taxRates={comboTax}
                                        />
                                    </div>

                                    <div className="col-md-3">
                                        <label>Duration In Minute <span className="text-danger">*</span></label>
                                        <input
                                            className="form-control"
                                            placeholder="Duration In Minute"
                                            value={timeValue1}
                                            onChange={(e) => handleFieldChange(e, "timeValue1")}
                                        />
                                    </div>


                                    {/* <div className="col-md-3">
                                        <label>SkyCoins <span className="text-danger">*</span></label>
                                        <input
                                            className="form-control"
                                            placeholder="SkyCoins"
                                            value={playPoint}
                                            onChange={(e) => handleFieldChange(e, "playPoint")}
                                        />
                                        {error.playPoint && <small className="text-danger">{error.playPoint}</small>}
                                    </div> */}

                                    <div className="col-md-3">
                                        <label>MRP (Normal) <span className="text-danger">*</span></label>
                                        <input
                                            className="form-control"
                                            placeholder="Amount"
                                            value={amount}
                                            onChange={(e) => handleFieldChange(e, "amount")}
                                        />
                                        {error.amount && <small className="text-danger">{error.amount}</small>}
                                    </div>
                                    <div className="col-md-3">
                                        <label>MRP (SPCL)
                                            {/* <span className="text-danger">*</span> */}
                                        </label>
                                        <input
                                            className="form-control"
                                            placeholder="Special MRP"
                                            value={specialAmount}
                                            onChange={(e) => handleFieldChange(e, "specialAmount")}
                                        />
                                        {error.specialAmount && <small className="text-danger" style={{ fontSize: "12px" }}>{error.specialAmount}</small>}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="IsAddOn" className="form-label">
                                                IsAddOn
                                            </label>
                                            <div className="form-check">
                                                {/* <input
                                                    type="checkbox"
                                                    className="form-check-input ms-1"
                                                    id="IsAddOn"
                                                    //checked={Boolean(isAddOn)}
                                                    checked={isAddOn !== null}
                                                    onChange={handleCheckboxChange}
                                                    style={{ border: '2px solid black' }}
                                                /> */}
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input ms-1"
                                                    id="IsAddOn"
                                                    checked={isAddOn === true}
                                                    onChange={handleCheckboxChange}
                                                    style={{ border: '2px solid black' }}
                                                />


                                            </div>
                                        </div>
                                    </div>

                                    {isAddOn === true && (
                                        <div className="col-md-4">
                                            <AddOnList
                                                selectedAddOn={addOnId}
                                                setSelectedAddOn={setAddOnId}
                                                selectedActivityCenter={selectedActivityCenter}
                                            />
                                        </div>
                                    )}

                                    {/* {isAddOn !== null && (
                                        <div className="col-md-4">
                                            <AddOnList
                                                selectedAddOn={addOnId}
                                                setSelectedAddOn={setAddOnId}
                                                selectedActivityCenter={selectedActivityCenter}
                                            />
                                        </div>
                                    )} */}
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-primary" type="button" onClick={handleUpdate} >Update</button>
                                <button type="button" id="closeUpdateModal" className="btn btn-secondary" onClick={handleClose} data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="modal" id="myModalActivityList">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Activity Details</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">

                                <table className="table table-bordered border-secondary">
                                    <thead>
                                        <tr>

                                            <th>Center Name</th>
                                            <th>Activity Type</th>
                                            <th>Activity Name</th>
                                        </tr>
                                        <tr>
                                            <td>{centerName}</td>
                                            <td>{activityTypeName}</td>
                                            <td>{activityName}</td>

                                        </tr>
                                        <tr>
                                            <th>Product Name</th>
                                            <th colSpan={2}> {productName}</th>
                                        </tr>

                                        <tr>
                                            <td>Duration in Minute</td>

                                            <td>MRP (Normal)</td>
                                            <td>MRP (SPCL)</td>
                                            {/* <td>SkyCoins</td> */}

                                        </tr>
                                        <tr>
                                            <td>{timeValue1}</td>

                                            <td>{amount}</td>
                                            <td>{specialAmount}</td>
                                            {/* <td>{playPoint}</td> */}

                                        </tr>
                                        <tr>
                                            <td>AddonName</td>
                                            <td>Tax Rate Name</td>
                                            <td>Status</td>
                                        </tr>
                                        <tr>
                                            <td>{mapAddonName}</td>
                                            <td>{comboTaxName}</td>
                                            <td>{status ? "Active" : "De-Activated"}</td>
                                        </tr>
                                        <tr>
                                            <td>Created Date</td>
                                        </tr>
                                        <tr>
                                            <td>{moment(createdAt).format("DD-MM-YYYY")}                                            </td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div className="modal-footer">

                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>

    );
};

export default ProductActivityList;